<template>
	<div class="authentication">
		<h1>如何进行企业认证?</h1>
		<h5>仅需四步，成功认证</h5>
		<div class="step">
			<div class="stepItem" v-for="(item,index) in stepList">
				<div class="step-title">
					<p class="stepNumber">STEP 0{{index+1}}</p>
					{{item.title}}
				</div>
				<div class="step-ring"></div>
				<div class="step-stepMsg">{{item.stepMsg}}</div>
			</div>
			<div class="step-line"></div>
		</div>
		<div class="statement">声明：您的认证信息仅用作AB客系统企业身份认证使用，不会用作他处。</div>
	</div>
</template>

<script>
	export default {
		name: "authentication",
		data(){
			return {
				stepList:[{
					title:'登录网址',
					stepMsg:'打开浏览器输入crm.cnabke.com',
					id:1
				},{
					title:'申请认证',
					stepMsg:'完成登录—点击个人头像—点击账户中心—点击认证中心—点击公司认证—编辑认证资料',
					id:2
				},{
					title:'填写资料',
					stepMsg:'营业执照公司名称、法人姓名、营业执照',
					id:3
				},{
					title:'立即申请',
					stepMsg:'完成企业认证',
					id:4
				}]
			}
		}
	}
</script>

<style scoped>
	.authentication {
		overflow: scroll;
		background-color: #3B3DF4;
		background-image: url("../Assets/img_banner.png");
		background-size: 100% auto;
		width: 100%;
		background-repeat: no-repeat;
		padding: 15px;
		min-height: 100%;
	}

	.authentication h1,
	.authentication h5 {
		text-align: center;
		color: #FFFFFF;
		font-family: PingFang SC;
		letter-spacing: 2px;
	}

	.authentication h1 {
		margin-top: 7px;
		font-size: 25px;
		font-weight: bold;
	}

	.authentication h5 {
		margin-top: 10px;
		font-size: 12px;
		font-weight: 400;
	}
	.step {
		overflow: hidden;
		position: relative;
		background: white;
		border-radius: 8px;
		margin: 50px auto 0;
		padding-bottom: 20px;
	}
	.stepItem{
		margin-top: 20px;
		width: 100%;
		display: flex;
		align-items: center;
		position: relative;
		z-index: 1;
	}
	.step-line {
		left: 87px;
		position: absolute;
		top: 0;
		border-left: 1px dashed #CDCDCD;
		height: 100%;
		z-index: 0;
	}
	.step-title{
		width: 81px;
		color: #3B3DF4;
		position: relative;
		text-align: center;
	}
	.step-ring{
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background: #FFFFFF;
		border: 1px solid #3B3DF4;
	}
	.step-stepMsg{
		width: 227px;
		padding: 20px 15px;
		background: #FFFFFF;
		border: 1px solid #CDCDCD;
		box-shadow: 0px 1px 6px 0px rgba(147, 147, 147, 0.2);
		border-radius: 4px;
		margin-left: 10px;
	}
	.stepNumber{
		position: absolute;
		top: -13px;
		font-size: 11px;
		font-family: PingFang SC;
		color: #CCCCCC;
		width: 100%;
	}
	.statement{
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 18px;
		opacity: 0.3;
		margin-top: 14px;
	}
</style>
